/* eslint-disable no-undef */

import { Platform, StyleSheet } from 'react-native';
import { widthInPercentage } from '../../../utils/appUtils';

export default StyleSheet.create({
  centeredView: {
    alignItems: 'center',
    marginVertical: widthInPercentage(5),
    marginLeft: '20%',
    marginRight: '20%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 50,
    paddingRight: 50, paddingVertical: 10
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2
    // },
    // shadowOpacity: 0.25,
    // shadowRadius: 3.84,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2
    // },
    // shadowOpacity: 0.38,
    // shadowRadius: 3.84,
  },
  centeredView_XHDPI: {
    padding: 2,
    marginVertical: widthInPercentage(3),
  },
  centeredViewForMobile_MDPI: {
    padding: 30,
    marginTop: 20
  },
  centeredCibiltermsView: {
    //alignItems: 'center',
    marginVertical: widthInPercentage(2),
    marginLeft: '5%',
    marginRight: '5%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 50,
    paddingRight: 50, 
    paddingVertical: 8

  },
  centeredCibiltermsView_XHDPI: {
    padding: 2,
    marginVertical: widthInPercentage(3),
  },
  centeredCibiltermsViewForMobile: {
    alignItems: 'center',
    backgroundColor: 'white',
    height: '100%',
    width: '100%',
    padding: 20,
    marginTop: widthInPercentage(10),

  },
  centeredCibiltermsViewForMobile_MDPI: {
    padding: 30,
    backgroundColor: 'white',
    marginTop: 20
  },
  centeredCibiltermsView_LDPI: {
    alignItems: 'center',
    marginVertical: widthInPercentage(2),
    marginLeft: '5%',
    marginRight: '5%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 50,
    paddingRight: 50, paddingVertical: 8

  },
  centeredCibiltermsView_MDPI: {
    alignItems: 'center',
    marginVertical: widthInPercentage(2),
    marginLeft: '5%',
    marginRight: '5%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 50,
    paddingRight: 50, paddingVertical: 8

  },
  centeredCibiltermsView_HDPI: {
    alignItems: 'center',
    marginVertical: widthInPercentage(2),
    marginLeft: '5%',
    marginRight: '3%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 30,
    paddingRight: 30, paddingVertical: 8

  },
  centeredCibilDataView: {
    alignItems: 'center',
    marginVertical: widthInPercentage(1),
    marginLeft: '5%',
    marginRight: '3%',
    backgroundColor: 'white',
    borderRadius: 12,
    paddingLeft: 30,
    paddingRight: 30, paddingVertical: 8

  },
  centeredCibilDataView_XHDPI: {
    padding: 2,
    marginVertical: widthInPercentage(3),
  },

  centeredCibilDataViewForMobile: {
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: 20,
    marginTop: widthInPercentage(10),

  },
  centeredCibilDataViewForMobile_MDPI: {
    padding: 30,
    marginTop: 20
  },
  modalView: {
    backgroundColor: 'white',
    borderColor: 'white',
    width: '100%',
    height: '100%'
  },
  submitBtn: {
    width: '50%',
    height: 60,
    justifyContent: 'center',
    // shadowOpacity: 2,
    // shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#2a5298',
    padding: 10,
    borderRadius: 5,
    marginTop: 1
  },
  submitBtn_MDPI: {
    marginTop: 15
  },
  submitBtn_LDPI: {
    marginTop: 15
  },
  submitBtn_HDPI: {
    marginTop: 15
  },
  submitBtn_XHDPI: {
    marginTop: 10,

    height: 40,
  },
  newserviceText: {
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 18,
    color: '#fff'
  },
  newserviceText_XHDPI: {
    fontSize: 17
  },
  componentSubHeading: {
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Mulish',
    textAlign: 'center',
    color: '#000000'
  },
  compBody: {
    fontSize: 14,
    fontFamily: 'Mulish',
    //color: '#707070',
    marginTop: 5,
    lineHeight: 30,
    width: '100%',
    height: '100%',
    fontWeight: '400'
  },
  compBody_XHDPI: {
    lineHeight: 25,
    marginTop: 5
  },
  compBody_LHDPI: {
    lineHeight: 25,
    marginTop: 15
  },
  compBody_MHDPI: {
    lineHeight: 25,
    marginTop: 15
  },
  compBodyTC: {
    fontSize: 14,
    fontFamily: 'Mulish',
    color: '#707070',
    marginTop: 10,
    lineHeight: 30,
    width: '100%',
    height: '100%',
    fontWeight: '500',
    textAlign: 'center'
  },
  compBodyTC_XHDPI: {
    lineHeight: 25,
    marginTop: 5
  },
  compBodyTC_LHDPI: {
    lineHeight: 25,
    marginTop: 15
  },
  compBodyTC_MHDPI: {
    lineHeight: 25,
    marginTop: 15
  },
  centeredViewForMobile: {
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: 20,
    marginTop: widthInPercentage(10),
    /***** */
    // backgroundColor: "white",
    // borderRadius: 20,
    // padding: 35,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2
    // },
    // shadowOpacity: 0.25,
    // shadowRadius: 3.84,
    /**** */
    // justifyContent: 'center',
    //     alignItems: 'center',
  },
  modalViewForMobile: {
    backgroundColor: 'white',
    borderColor: 'white',
    width: '100%',
    height: '100%'
  },
  compBodyForMobile: {
    fontSize: 16,
    fontFamily: 'Mulish',
    color: '#707070',
    marginTop: 30,
    lineHeight: 35,
    // fontWeight:500,
    width: Platform.OS == 'web' ? '100%' : null,
    height: Platform.OS == 'web' ? '100%' : null
  },
  compBodyTCForMobile: {
    fontSize: 16,
    fontFamily: 'Mulish',
    color: '#707070',
    marginTop: 30,
    lineHeight: 35,
    // fontWeight:500,
    width: Platform.OS == 'web' ? '100%' : null,
    height: Platform.OS == 'web' ? '100%' : null,
    textAlign: 'center'
  },
  agreementView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginRight: '2%'
  },
  agreeButton: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    marginHorizontal: '5%'
  },
  agreeButton_MDPI: {
    marginHorizontal: '0%',
    flex: 2
  },
  agreeButton_LDPI: {
    marginHorizontal: '0%',
    flex: 2
  },
  textStyle: {
    color: 'white',
    textAlign: 'center',
    padding: 15
  },
  textStyle_MDPI: { padding: 10 },
  textStyle_LDPI: { padding: 10 },
  textStyle_HDPI: { padding: 10 },
  newserviceTextForMobile: {
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 18,
    color: '#fff',
    justifyContent: 'center',
    alignItems: 'center'
  },
  submitBtnforMobile: {
    width: '70%',
    height: 50,
    justifyContent: 'center',
    // shadowOpacity: 2,
    // shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#2a5298',
    padding: 10,
    borderRadius: 5,
    marginTop: 30,
    alignItems: 'center'
  },
  submitBtnforMobile_MDPI: {
    marginTop: 15
  },
  submitBtnforMobile_LDPI: {
    marginTop: 15
  },
  submitBtnforMobile_HDPI: {
    marginTop: 15
  },
  submitBtnforMobile_XHDPI: {
    marginTop: 15
  },
  checkox:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: 10, marginRight: 0
  },
  checkox_LDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(10), marginRight: 0
  },
  checkox_MDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(10), marginRight: 0
  },
  checkox_HDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(5), marginRight: 0
  },
  checkox_XHDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(5), marginRight: 0
  },
  checkox_XXHDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(5), marginRight: 0
  },
  checkox_XXHDPI:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(5), marginRight: 0
  },
  checkox_LAPTOP:
  {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: widthInPercentage(2), marginRight: 0
  },
  termsnadcontntext: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 10
  },
  termsnadcontntextbold: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 10,
  },
  termsnadcontntextTC: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 10,
    paddingBottom: 16
  },
  scrollStyle:
  {
    height: 300
  },
  scrollStyle_LAPTOP:
  {
    height: 300
  },
  scrollStyle_XHDPI:
  {
    height: 270
  },
  PaymentBackButton:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PaymentBackButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PaymentBackButton_LDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(15),
    height: widthInPercentage(15),
    paddingBottom: '2%',
    marginBottom: widthInPercentage(20),
    paddingTop: '5%',
  },
  PaymentBackButton_MDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(15),
    height: widthInPercentage(15),
    paddingBottom: '2%',
    marginBottom: widthInPercentage(20),
    paddingTop: '5%'
  },
  PaymentBackButton_HDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(16),
    height: widthInPercentage(15),
    paddingBottom: '2%',
    marginBottom: widthInPercentage(20),
    paddingTop: '5%'
  },
  PaymentHomeButton:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PaymentHomeButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PaymentHomeButton_LDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(5),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(23)
  },
  PaymentHomeButton_MDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(5),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(23)
  },
  PaymentHomeButton_HDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(5),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(23)
  },
  loaderImageView:
  {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '10%',
    flex: 1
  },
  loadingImagestyle: {
    width: 80,
    height: 80
  },

  PayHomeButtonTermandCond:
  {
    width: widthInPercentage(55),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButtonTermandCond_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PayHomeButtonTermandCond_LDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(2),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: 0,
    paddingLeft: widthInPercentage(50)
  },
  PayHomeButtonTermandCond_MDPI:
  {
    // width: widthInPercentage(55),
    // position: 'absolute',
    // marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButtonTermandCond_HDPI:
  {
    width: widthInPercentage(15),
    position: 'none',
    marginTop: 0,
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: 0
  },
  PayHomeButtonTermandCond_XXHDPI:
  {
    // width: widthInPercentage(50),
    //position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PayBackButtonTermandCond:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButtonTermandCond_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButtonTermandCond_XXHDPI:
  {
    width: widthInPercentage(50),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginTop: widthInPercentage(8)
  },
  PayBackButtonTermandCond_LDPI:
  {
    // width: widthInPercentage(50),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(0),
    paddingRight: widthInPercentage(44),
    marginTop: widthInPercentage(2),
    marginRight: widthInPercentage(5),
  },
  PayBackButtonTermandCond_MDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10),
    paddingRight: widthInPercentage(50)
  },
  PayBackButtonTermandCond_HDPI:
  {
    width: widthInPercentage(50),
    // position: 'absolute',
    // marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  combinedViewMobtandc: {
    marginTop: '13%',
    zIndex: 3,
    height: '20%',
    display: 'flex',
    flexDirection: 'row'
  },
  Newcombview: {
    flexDirection: 'row',
    width: '100%',
    marginTop: '13%',
    marginHorizontal: '5%'
  },
  Newcombviews: {
    flexDirection: 'row',
    width: '100%',
    marginTop: '30%',
    marginHorizontal: '5%'
  },
  Upperview: {
    flex: 1
  },
  Upperview_MDPI: {
    flex: 1
  },
  Upperview_LDPI: {
    flex: 1
  },
  Lowerview: {
    flex: 1
  },
  Lowerview_HDPI: {
    flex: 1,
    marginRight: '55%'
  },
  Lowerview_MDPI: {
    flex: 1,
    marginRight: '62%'
  },
  Lowerview_LDPI: {
    flex: 1,
    marginRight: '30%'
  },
  TopnavMobileLogostyle: {
    width: 140,
    height: 60
  },
  Headtext: {
    fontSize: 14,
    fontFamily: 'Mulish',
    //color: '#707070',
    //marginTop: 5,
    lineHeight: 18,
    width: '100%',
    height: '100%',
    fontWeight: '400'
  },
  Headtext_XHDPI: {
    marginTop: 5
  },
  Headtext_LHDPI: {
    marginTop: 15
  },
  Headtext_MHDPI: {
    marginTop: 15
  },
  HeadtextMobile: {
    fontSize: 16,
    fontFamily: 'Mulish',
    color: '#707070',
    marginTop: 30,
    lineHeight: 35,
    // fontWeight:500,
    width: Platform.OS == 'web' ? '100%' : null,
    height: Platform.OS == 'web' ? '100%' : null
  },
  Newcombviewpayamt: {
    flexDirection: 'row',
    width: '100%',
    marginTop: '13%',
    marginHorizontal: '5%'
  },
  Newcombviewpayamt_LDPI: {
    flexDirection: 'row',
    width: '50%',
    marginTop: '35%',
    //marginHorizontal: '5%'
  },
  Newcombviewpayamt_MDPI: {
    flexDirection: 'row',
    width: '50%',
    marginTop: '35%',
   // marginHorizontal: '5%'
  },
  Newcombviewpayamt_HDPI: {
    flexDirection: 'row',
    width: '50%',
    marginTop: '35%',
    //marginHorizontal: '5%'
  },
  Upperviewpayamt: {
    flex: 1
  },
  Upperviewpayamt_MDPI: {
    flex: 0.5
  },
  Upperviewpayamt_LDPI: {
    flex: 0.5
  },
  Upperviewpayamt_LDPI: {
    flex: 0.5
  },
  PayHomeButton:
  {
    width: widthInPercentage(55),
    position: 'absolute',
    marginTop: widthInPercentage(1),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PayHomeButton_LDPI:
  {
    width: widthInPercentage(40),
    // position: 'absolute',
    // marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    //paddingVertical: '1%',
    marginBottom: widthInPercentage(5)
  },
  PayHomeButton_MDPI:
  {
    width: widthInPercentage(40),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(15),
    //paddingVertical: '1%',
    marginBottom: widthInPercentage(5)
  },
  PayHomeButton_HDPI:
  {
    width: widthInPercentage(40),
    position: 'none',
    marginTop: 0,
    height: widthInPercentage(15),
    //paddingVertical: '1%',
    marginBottom: widthInPercentage(5)
  },
  updatedView: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  PayBackButton:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButton_LDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10),
    marginLeft: '19%'
  },
  PayBackButton_MDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10),
    //marginLeft: widthInPercentage(16)
  },
  PayBackButton_HDPI:
  {
    width: widthInPercentage(50),
    // position: 'absolute',
    // marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  
  
});
